export class VueRouteHelper {
    static goTo(path, router) {
        if (router.currentRoute.path == path) return;

        router.push(path);
    }

    static inNewTab(path, router) {
        if (router.currentRoute.path == path) return;

        let routeData = router.resolve(path);
        window.open(routeData.href, '_blank');
    }

    static goBack(router) {
        router.go(-1);
    }
}